// Add type declaration at the top of the file
declare global {
  interface Window {
    colyseus: any;
  }
}

export class Scoreboard {
  private container: HTMLDivElement;
  private homeTeamName: string;
  private awayTeamName: string;
  private homeScore: number = 0;
  private awayScore: number = 0;
  private waitingMessage: string | null = 'Waiting for Players...';
  private isGameActive: boolean = false;
  private readonly POINTS_TO_WIN = 21;
  
  constructor(teamAName: string, teamBName: string) {
    this.homeTeamName = teamAName;
    this.awayTeamName = teamBName;
    // Create the scoreboard container
    this.container = document.createElement('div');
    this.container.classList.add('scoreboard');
    
    // Build the scoreboard content
    this.buildScoreboard();
    
    // Add the scoreboard to the UI container
    const uiContainer = document.getElementById('ui-container');
    if (uiContainer) {
      uiContainer.appendChild(this.container);
    }

    
  }
  
  private buildScoreboard(): void {
    this.homeScore = 0;
    this.awayScore = 0;
    // Clear existing content
    this.container.innerHTML = '';

    // Set container styles
    this.container.style.position = 'fixed';
    this.container.style.top = '0';
    this.container.style.left = '50%';
    this.container.style.right = '0';
    this.container.style.padding = '10px';
    this.container.style.display = 'flex';
    this.container.style.justifyContent = 'center';
    this.container.style.alignItems = 'center';
    this.container.style.fontSize = '24px';
    this.container.style.fontWeight = 'bold';
    
    // Create score display elements
    const homeTeamDiv = document.createElement('div');
    homeTeamDiv.style.backgroundColor = '#ff4444';
    homeTeamDiv.style.color = 'white';
    homeTeamDiv.style.padding = '5px 15px';
    homeTeamDiv.style.borderRadius = '4px';
    homeTeamDiv.textContent = this.homeTeamName;
    
    const homeScoreSpan = document.createElement('span');
    homeScoreSpan.id = 'home-score';
    homeScoreSpan.textContent = this.homeScore.toString();
    homeScoreSpan.style.margin = '0 10px';
    
    const separator = document.createElement('span');
    separator.textContent = '|';
    separator.style.margin = '0 10px';
    
    const awayScoreSpan = document.createElement('span');
    awayScoreSpan.id = 'away-score';
    awayScoreSpan.textContent = this.awayScore.toString();
    awayScoreSpan.style.margin = '0 10px';
    
    const awayTeamDiv = document.createElement('div');
    awayTeamDiv.style.backgroundColor = '#4444ff';
    awayTeamDiv.style.color = 'white';
    awayTeamDiv.style.padding = '5px 15px';
    awayTeamDiv.style.borderRadius = '4px';
    awayTeamDiv.textContent = this.awayTeamName;

    if (this.waitingMessage) {
      const gameInfoDiv = document.createElement('div');
      gameInfoDiv.style.textAlign = 'center';
      gameInfoDiv.style.fontSize = '0.9em';
      gameInfoDiv.style.opacity = '0.8';
      gameInfoDiv.textContent = this.waitingMessage;
      this.container.appendChild(gameInfoDiv);
    } else {
      this.container.appendChild(homeTeamDiv);
      this.container.appendChild(homeScoreSpan);
      this.container.appendChild(separator);
      this.container.appendChild(awayScoreSpan);
      this.container.appendChild(awayTeamDiv);
    }
  }
  
  /**
   * Update team names
   */
  public updateTeamNames(home: string, away: string): void {
    this.homeTeamName = home;
    this.awayTeamName = away;
    
    // Update the displayed team names
    const homeElement = this.container.querySelector('div > div:first-child > strong');
    const awayElement = this.container.querySelector('div > div:last-child > strong');
    
    if (homeElement) {
      homeElement.textContent = home;
    }
    
    if (awayElement) {
      awayElement.textContent = away;
    }
  }
  
  /**
   * Update score values
   */
  public updateScore(home: number, away: number): void {
    if (this.homeScore == home && this.awayScore == away) {
      return;
    }
    this.homeScore = home;
    this.awayScore = away;
    
    // Update the displayed scores
    const homeScoreElement = document.getElementById('home-score');
    const awayScoreElement = document.getElementById('away-score');
    
    if (homeScoreElement) {
      homeScoreElement.textContent = home.toString();
    }
    
    if (awayScoreElement) {
      awayScoreElement.textContent = away.toString();
    }
  }
  
  /**
   * Start the game
   */
  public startGame(): void {
    // Clear waiting message
    this.waitingMessage = null;
    this.isGameActive = true;
    
    // Rebuild the scoreboard with game info
    this.buildScoreboard();
  }

  /**
   * Pause the game
   */
  public pauseGame(): void {
    // Show waiting message
    this.waitingMessage = 'Waiting for Players...';
    this.isGameActive = false;
    
    // Rebuild the scoreboard
    this.buildScoreboard();
  }

  public getGameActive(): boolean {
    return this.isGameActive;
  }

  /**
   * Handle game over
   */
  public handleGameOver(): void {
    // Display end game message
    const endGameMessage = document.createElement('div');
    endGameMessage.classList.add('modal-overlay');
    
    const endGameContent = document.createElement('div');
    endGameContent.classList.add('modal-content', 'end-game-screen');
    
    // Determine the winner
    const winnerText = document.createElement('div');
    winnerText.classList.add('winner-text');
    
    // Update internal scores one last time to ensure accuracy
    const finalHomeScore = this.homeScore;
    const finalAwayScore = this.awayScore;
    
    if (finalHomeScore > finalAwayScore) {
      winnerText.textContent = `${this.homeTeamName} Wins!`;
    } else if (finalAwayScore > finalHomeScore) {
      winnerText.textContent = `${this.awayTeamName} Wins!`;
    }
    
    // Show final score
    const scoreDisplay = document.createElement('div');
    scoreDisplay.classList.add('score-display');
    scoreDisplay.textContent = `${finalHomeScore} - ${finalAwayScore}`;
    
    
    
    // Main menu button
    const mainMenuButton = document.createElement('button');
    mainMenuButton.textContent = 'Main Menu';
    mainMenuButton.addEventListener('pointerdown', () => {
      window.location.href = window.location.pathname;
    });
    
    // Button group
    const buttonGroup = document.createElement('div');
    buttonGroup.classList.add('button-group');
    
    buttonGroup.appendChild(mainMenuButton);
    
    // Add all elements to the content
    endGameContent.appendChild(winnerText);
    endGameContent.appendChild(scoreDisplay);
    endGameContent.appendChild(buttonGroup);
    
    // Add content to the overlay
    endGameMessage.appendChild(endGameContent);
    
    // Add to the UI container
    const uiContainer = document.getElementById('ui-container');
    if (uiContainer) {
      uiContainer.appendChild(endGameMessage);
    }
  }
} 